module.exports = __webpack_public_path__ + "static/media/jobs_top.4ae89c72.jpg";